import request from '@/utils/request'

let XieyiApi = {

  /*协议列表*/
  list(data) {
    return request._post('/shop/plus.xieyi.Index/index', data);
},
/*添加协议*/
add(data) {
    return request._post('/shop/plus.xieyi.Index/add', data);
},
/*修改协议*/
edit(data) {
    return request._post('/shop/plus.xieyi.Index/edit', data);
},
/*删除协议*/
del(data) {
    return request._post('/shop/plus.xieyi.Index/del', data);
},
/*协议详情*/
detail(data) {
  return request._post('/shop/plus.xieyi.Index/detail', data);
},

}
export default XieyiApi;



// WEBPACK FOOTER //
// ./src/api/xieyi.js